import React from "react";
import { graphql, StaticQuery } from "gatsby";
import { RichText as PrismicRichText } from "prismic-reactjs";

import {
  SectionWrapper,
  Box,
  Button,
  FlexGrid,
  RichText,
  Textarea,
  TextInput,
  SEO
} from "src/components";

import serializer from "src/utils/serializer";
import linkResolver from "src/utils/linkResolver";

const ContactPage = ({ preview }) => (
  <StaticQuery
    query={graphql`
      {
        prismicContact {
          dataString
        }
      }
    `}
    render={data => {
      let page = JSON.parse(data.prismicContact.dataString);
      if (preview) {
        page = preview;
      }
      return (
        <SectionWrapper>
          <SEO
            image={page.seo_image && page.seo_image.url}
            title={page.seo_title && PrismicRichText.asText(page.seo_title)}
            description={
              page.seo_description &&
              PrismicRichText.asText(page.seo_description)
            }
          />
          <FlexGrid width={1} gutterX={[3]}>
            <article
              css={`
                width: 67%;
                @media (max-width: 64rem) {
                  width: 100%;
                }
              `}
            >
              <Box
                as="form"
                my={6}
                name="contactForm"
                method="post"
                action="/success"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
              >
                <input type="hidden" name="form-name" value="contactForm" />
                <input type="hidden" name="bot-field" />
                <div
                  css={`
                    max-width: 600px;
                  `}
                >
                  <Box pb={5}>
                    <FlexGrid gutterX={[3]} gutterY={[2]}>
                      <Box width={[1, 1 / 2]}>
                        <TextInput
                          label={`First name`}
                          type="text"
                          name="firstName"
                        />
                      </Box>
                      <Box width={[1, 1 / 2]}>
                        <TextInput
                          label={`Last name`}
                          type="text"
                          name="lastName"
                        />
                      </Box>
                      <Box width={1}>
                        <TextInput
                          label={`Email address`}
                          type="email"
                          name="email"
                        />
                      </Box>
                      <Box width={1}>
                        <Textarea
                          label={`Message`}
                          rows="6"
                          message="message"
                          name="message"
                        />
                      </Box>
                    </FlexGrid>
                  </Box>
                  <Button children={`Submit`} variant="primary" />
                </div>
              </Box>
            </article>
            <aside
              css={`
                width: 33%;
                @media (max-width: 64rem) {
                  width: 100%;
                }
              `}
            >
              <section
                css={`
                  margin: 64px 0;
                  @media (max-width: 64rem) {
                    margin: 0 0 64px;
                  }
                `}
              >
                <RichText>
                  {page.contact &&
                    PrismicRichText.render(
                      page.contact,
                      linkResolver,
                      serializer
                    )}
                </RichText>
              </section>
            </aside>
          </FlexGrid>
        </SectionWrapper>
      );
    }}
  />
);

export default ContactPage;
